export default {
  MAPS_API_TOKEN: 'https://api.maptiler.com/maps/basic/style.json?key=owErAUsX1uv65c8aUM4y'
}
